import Vue from 'vue';
import axios from 'axios';
import {
    AUTH_LOGOUT,
    USER_REQUEST,
    USER_ERROR,
    USER_SUCCESS,
    SYNC_USER,
} from '../actions';

const state = {
    status: '',
    profile: {},
    flagAsideUpdating: false,
};

const getters = {
    getProfile: state => state.profile,
    isProfileLoaded: state => !!state.profile.name,
    hasPermission: (state) => (value) => {
        if (!!state.profile.name) {
            for (let i = 0; i < state.profile.permissions.data.length; i++) {
                if (state.permissions.data[i].name == value) {
                    return true;
                }
            }
            for (let i = 0; i < state.profile.roles.data.length; i++) {
                let role = state.profile.roles.data[i];
                for (let j = 0; j < role.permissions.data.length; j++) {
                    //console.log("PERMISSION" + role.permissions[j].name, role.permissions[j]);
                    console.log(role.permissions.data[j].name, value);
                    if (role.permissions.data[j].name == value) {
                        return true;
                    }
                }
            }
        }
        return false;
    },
    hasRole: (state) => (value) => {
        if (state.profile.name) {
            for (let i = 0; i < state.profile.roles.data.length; i++) {
                let role = state.profile.roles.data[i];
                if (role.name == value) {
                    return true;
                }
            }
        }
        return false;
    },
    hasDashboardAccess: (state) => (value) => {
        if (state.profile.name) {
            if (state.profile.config && state.profile.config.dashboard) {
                for (let i = 0; i < state.profile.config.dashboard.length; i++) {
                    let opt = state.profile.config.dashboard[i];
                    if (opt == value) {
                        return true;
                    }
                }
            }
            for (let i = 0; i < state.profile.roles.data.length; i++) {
                let role = state.profile.roles.data[i];
                if (role.config && role.config.dashboard) {
                    for (let j = 0; j < role.config.dashboard.length; j++) {
                        let opt = role.config.dashboard[j];
                        if (opt == value) {
                            return true;
                        }
                    }
                }
                if (role.name == "Super Admin") {
                    return true;
                }
                if (role.name == "B79 Admin") {
                    return true;
                }
            }
        }
        return false;
    },
    flagAsideUpdating: state => state.flagAsideUpdating,
};

const actions = {
    [USER_REQUEST]: ({commit, dispatch}, profile) => {
        if (profile.name) {
            commit(USER_SUCCESS, profile);
        } else {
            commit(USER_REQUEST);
            axios.get('/me').then(res => {
                commit(USER_SUCCESS, res.data.data);
            }).catch(() => {
                commit(USER_ERROR);
                dispatch(AUTH_LOGOUT);
            });
        }
    },
    [SYNC_USER]: ({commit, dispatch, state}, callback) => {
        console.log(String.fromCodePoint(0x1F504) + ' SYNC_USER');
        if (state.profile.name) {
            console.log(String.fromCodePoint(0x2705) + ' User profile exists.');
            callback(state.profile);
        } else {
            console.log(String.fromCodePoint(0x274E) + ' User profile does not exist, loading...');
            commit(USER_REQUEST);
            axios.get('/me').then(res => {
                commit(USER_SUCCESS, res.data.data);
                callback(res.data.data);
            }).catch(() => {
                commit(USER_ERROR);
                dispatch(AUTH_LOGOUT);
            });
        }
    },
    [AUTH_LOGOUT]: (context) => {
        context.commit(AUTH_LOGOUT)
    },
};

const mutations = {
    [USER_REQUEST]: (state) => {
        state.status = 'loading';
    },
    [USER_SUCCESS]: (state, profile) => {
        state.status = 'success';
        Vue.set(state, 'profile', profile);
    },
    [USER_ERROR]: (state) => {
        state.status = 'error';
    },
    [AUTH_LOGOUT]: (state) => {
        console.info(String.fromCodePoint(0x1F44B) + ' Leaving App.User.' + state.profile.id + ' channel from AUTH_LOGOUT.');
        Vue.prototype.$echo.leave('App.User.' + state.profile.id)   ;
        state.profile = {};
    },
    updateUserFlagCount: (state, flag_count) => {
        state.profile.flag_count = flag_count;
    },
    updatingUserFlagsAsideDrawer: (state, updating) => {
        // console.log('flag aside updating', updating);
        state.flagAsideUpdating = updating;
    }
};

export default {
    state,
    getters,
    actions,
    mutations,
};
